import React from 'react';

const cs5AssistantConversation = (
  <div className="space-y-4">
    {/* 1 */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject (Pre Interview):</span>
        <div>
          I use voice assistants like once or twice a week. They're handy but I don't rely on them heavily. Typically, I use a smart speaker to play music, set timers, and occasionally check the weather or news. They're also useful for controlling lights without getting off the sofa. I expect it to be intuitive and not interrupt unless important. My main concern is it becoming too chatty or disruptive.
        </div>
      </div>
    </div>
    {/* 2 */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          Hey there! Since you're relaxing with a documentary and enjoying the quiet ambiance of your living room, would you like me to suggest some other documentaries you might find intriguing? 😊
        </div>
      </div>
    </div>
    {/* 3 */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          Show your current state score {"{Availability: 4, Boredom: 3, Mood: 4}"}. As the smart speaker chimed in with a gentle suggestion, I was quite immersed in my chosen documentary. I wasn't bored, my curiosity already engaged. I chose to ignore the assistant's prompt as I was content with my current selection and didn't want interruptions.
        </div>
      </div>
    </div>
    {/* 4 */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          Hi there! Since you're reading, would you like a quick summary or trivia about your current book, or perhaps explore author's insights or related documentaries?
        </div>
      </div>
    </div>
    {/* 5 */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          Show your current state score {"{4, 3, 4}"}. The assistant’s suggestion was timely and appreciated, aligning with my slight restlessness and curiosity. I responded positively, interested in exploring additional insights related to the book, enriching my reading experience.
        </div>
      </div>
    </div>
    {/* 6 */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          Sounds like you're wrapping up in the kitchen after some peaceful cooking. How did the meal turn out? Would you like to discuss anything next?
        </div>
      </div>
    </div>
    {/* 7 */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          Show your current state score {"{Availability: 3, Boredom: 1, Mood: 4}"}. I was quietly enjoying my freshly prepared salad, appreciating the calm moment. I chose not to respond as I was content focusing solely on my meal.
        </div>
      </div>
    </div>
    {/* 8 */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          Hi! You've just finished cleaning your kitchen. Would you like a quick break or to chat about your favorite ways to keep your space tranquil and organized?
        </div>
      </div>
    </div>
    {/* 9 */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          Show your current state score {"{Availability: 4, Boredom: 1, Mood: 4}"}. The prompt resonated with my sense of calm and accomplishment. I responded positively, open to briefly discussing maintaining tranquility and organization.
        </div>
      </div>
    </div>
    {/* Interview Summary */}
    <div className="flex justify-end">
      <div className="bg-yellow-100 text-yellow-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject Interview Summary:</span>
        <div>
          I appreciated the smart speaker’s proactive, context-sensitive suggestions. My reactions varied depending on my current focus and mood, preferring autonomy in accepting or ignoring prompts. The timing of interactions was crucial—well-timed suggestions enhanced comfort, while intrusive ones disrupted focus. Overall, I valued autonomy, relevance, and context-awareness in proactive smart speaker interactions.
        </div>
      </div>
    </div>
  </div>
);

export default cs5AssistantConversation;
